<template>
    <div>
        <v-dialog v-model="showAiInstructionOption" @click:outside="closeDialog" persistent max-width="900">
            <v-card>
                <Loading />
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ quizTitle }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12" sm="12" md="8">
                                <v-textarea v-model="quizInstruction" :label="$t('instructAI')"
                                    :rules="[rules.required, rules.counter]" rows="1" maxlength="250"
                                    clearable></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-text-field v-model="noOfInstructions" :rules="[rules.minimumVal]" type="number"
                                    :label="$t('numberOfInstructions')" clearable></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="isExistingInstruction">
                            <v-col cols="12" sm="6" md="4">
                                <v-checkbox v-model="replaceExistingInstruction"
                                    :label="$t('replaceExistingInstructions')">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn @click="generateInstruction" class="text-capitalize" outlined>{{
                                $t('generateInstructions') }}</v-btn>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue'
export default {
    name: 'AiQuestionParameter',
    components: {
        Loading
    },
    data() {
        return {
            quiz: {},
            quizInstruction: '',
            replaceExistingInstruction: false,
            noOfInstructions: 0,
            rules: {
                required: value => !!value || this.$t('required'),
                counter: value => (value && value.length <= 250) || this.$t('max250characters'),
                minimumVal: value => value > 0 || 'The value must be greater than 0',
            },
        }
    },
    methods: {
        reset() {
            this.quizInstruction = ''
            this.replaceExistingInstruction = false
            this.noOfInstructions = 0
        },
        closeDialog() {
            this.$store.dispatch('dashboard/switchShowAiInstructionParameter', false)
        },
        generateInstruction() {
            if (this.$store.getters['dashboard/selectedAi'] == 'Gemini AI') {
                this.generateGeminiAiInstruction()
            } else {
                this.generateOpenAiInstruction()
            }
        },
        generateGeminiAiInstruction() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('dashboard/applyLoading')
                const objInstructions = {
                    quizTopicId: this.$store.getters['question/quiz'].quizTopicId,
                    quizInstruction: this.quizInstruction,
                    isDeletePreviousInstructions: this.replaceExistingInstruction,
                    previousInstructionsCount: this.$store.getters['quiz/existingInstructionsLenght'],
                    noOfInstructions: this.noOfInstructions,
                    addedBy: parseInt(localStorage.getItem('loggedUserId')),
                }
                //console.log(objInstructions)
                this.$store.dispatch('quiz/generateGeminiInstructions', objInstructions)
                    .then((response) => {
                        this.$store.dispatch('dashboard/cancelLoading')
                        if (response.status == 200) {
                            //console.log(response)
                            this.reset()
                            this.$store.dispatch('quiz/switchRefreshInstructions', true)
                            this.$store.dispatch('dashboard/switchShowAiInstructionParameter', false)
                        } else if (response.status == 202) {
                            this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        generateOpenAiInstruction() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('dashboard/applyLoading')
                const objInstructions = {
                    quizId: this.$store.getters['question/quiz'].quizTopicId,
                    quizInstruction: this.quizInstruction,
                    isDeletePreviousInstructions: this.replaceExistingInstruction,
                    previousInstructionsCount: this.$store.getters['quiz/existingInstructionsLenght'],
                    noOfInstructions: this.noOfInstructions,
                    addedBy: parseInt(localStorage.getItem('loggedUserId')),
                }
                //console.log(objInstructions)
                this.$store.dispatch('quiz/generateOpenAiInstructions', objInstructions)
                    .then((response) => {
                        //console.log(response)
                        this.$store.dispatch('dashboard/cancelLoading')
                        if (response.status == 200) {
                            this.reset()
                            this.$store.dispatch('dashboard/switchShowAiInstructionParameter', false)
                            this.$store.dispatch('quiz/switchRefreshInstructions', true)
                        } else if (response.status == 202) {
                            this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
    },
    computed: {
        showAiInstructionOption: function () {
            return this.$store.getters['dashboard/showAiInstructionParameter']
        },
        quizTitle: function () {
            return this.$store.getters['question/quiz'].quizTitle
        },
        isExistingInstruction: function () {
            return this.$store.getters['quiz/existingInstructionsLenght']
        },
    },
}
</script>